import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-comming-soon',
  templateUrl: './comming-soon.component.html',
  styleUrls: ['./comming-soon.component.css'],
  encapsulation:ViewEncapsulation.ShadowDom,standalone:false
})
export class CommingSoonComponent {

}
